import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { apiDisableUser } from '@services/ManageUserOperator/UserOperatorServices';
import { showSuccess, showError } from '@components/notification';

const DisableUserModal = ({ open, onClose, userInfo, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const handleDisable = async () => {
    try {
      setLoading(true);
      await apiDisableUser(userInfo.id);
      showSuccess({ message: 'Vô hiệu hóa người dùng thành công!' });
      onClose();
      onSuccess();
    } catch (error) {
      showError(error?.message || 'Không thể vô hiệu hóa người dùng');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <span>
          <ExclamationCircleOutlined style={{ color: '#f59e0b', marginRight: 8 }} />
          Xác nhận vô hiệu hóa người dùng
        </span>
      }
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Hủy
        </Button>,
        <Button
          key="disable"
          type="primary"
          loading={loading}
          onClick={handleDisable}
          style={{ backgroundColor: '#f59e0b', borderColor: '#f59e0b' }}>
          Vô hiệu hóa
        </Button>
      ]}>
      <p>
        Bạn có chắc chắn muốn vô hiệu hóa người dùng <strong>{userInfo?.user_name}</strong>?
      </p>
      <p style={{ color: 'var(--muted)', fontSize: '14px' }}>
        Sau khi vô hiệu hóa, người dùng này sẽ không thể đăng nhập vào hệ thống. Bạn có thể kích
        hoạt lại sau.
      </p>
    </Modal>
  );
};

export default DisableUserModal;
